import React, { useState, useEffect } from "react";

const PlotInventory = () => {
  const [plots, setPlots] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredPlots, setFilteredPlots] = useState([]);
  const [responseMessage, setResponseMessage] = useState(false);

  useEffect(() => {
    const fetchPlots = async () => {
      try {
        const response = await fetch(`https://api.swalokgroup.com/api/get-plots`);
        if (!response.ok) throw new Error("Failed to fetch reports");

        const data = await response.json();
        setPlots(data);
        setFilteredPlots(data); // Initially, show all plots
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchPlots();
  }, []);

  useEffect(() => {
    const lowerQuery = searchQuery.toLowerCase();

    const filtered = plots.filter((plot) => {
      return (
        (plot.plot_name && plot.plot_name.toLowerCase().includes(lowerQuery)) ||
        (plot.plot_number && plot.plot_number.toLowerCase().includes(lowerQuery)) ||
        (plot.category && plot.category.toLowerCase().includes(lowerQuery))
      );
    });

    setFilteredPlots(filtered);
  }, [searchQuery, plots]);


 const handleDelete = async (plotId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this plot?");
    if (!confirmDelete) return;

    try {
      const response = await fetch(`https://api.swalokgroup.com/api/delete-plot/${plotId}`, {
        method: "DELETE",
      });

      if (!response.ok) throw new Error("Failed to delete plot");

      setPlots((prev) => prev.filter((plot) => plot.id !== plotId));
      setFilteredPlots((prev) => prev.filter((plot) => plot.id !== plotId));

        setResponseMessage("Plot deleted successfully");
        setTimeout(() => {
          setResponseMessage("");        }, 1000);    } catch (error) {
      console.error(error);
    }
  };

  return (
    <section className="py-5">
      <div className="container">
        <div className="sec-subheading">
          <hr />
          <span>Plot Inventory</span>
          <hr />
        </div>

        {/* Search Bar */}
        <div className="my-3">
          <input
            type="text"
            className="form-input"
            placeholder="Search by Plot Name, No, or Category"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        <div className="table-responsive text-center mt-4">
          <table className="w-100">
            <thead>
              <tr className="bg-light para-text">
                <th className="py-3 px-2">Plot No</th>
                <th className="py-3 px-2">Plot Name</th>
                <th className="py-3 px-2">Category</th>
                <th className="py-3 px-2">Length</th>
                <th className="py-3 px-2">Breadth</th>
                <th className="py-3 px-2">Sq. Feet</th>
                <th className="py-3 px-2">Price/ Sq. Feet</th>
                <th className="py-3 px-2">Status</th>
                <th className="py-3 px-2">Activity</th>
              </tr>
            </thead>

            <tbody>
              {filteredPlots.length === 0 ? (
                <tr>
                  <td colSpan="9" className="py-3 px-2">
                    No plots found.
                  </td>
                </tr>
              ) : (
                filteredPlots.map((plot) => (
                  <tr
                    className="text-muted para-text text-capitalize"
                    key={plot.id}
                  >
                    <td className="py-3 px-2">{plot.plot_number}</td>
                    <td className="py-3 px-2">{plot.plot_name}</td>
                    <td className="py-3 px-2">{plot.category}</td>
                    <td className="py-3 px-2">{plot.length}</td>
                    <td className="py-3 px-2">{plot.breadth}</td>
                    <td className="py-3 px-2">{plot.total_sqfeet}</td>
                    <td className="py-3 px-2">₹{plot.price}</td>
                    <td
                      className={`py-3 px-2 ${
                        plot.status == 0
                          ? "text-success"
                          : plot.status == 1
                          ? "text-danger"
                          : plot.status == 2
                          ? "text-warning"
                          : plot.status == 3
                          ? "text-primary"
                          : ""
                      }`}
                    >
                      {plot.status == 0
                        ? "Not Booked"
                        : plot.status == 1
                        ? "Booked"
                        : plot.status == 2
                        ? "Agreement"
                        : plot.status == 3
                        ? "Registry"
                        : ""}
                    </td>
                    <td className="text-danger">{plot.status == 0 ? <span  onClick={() => handleDelete(plot.id)}><i class="fa-solid fa-trash" style={{cursor:'pointer'}}></i></span> : '-'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
                  {responseMessage && (
              <div className="response-message d-flex justify-content-between">
                <p className="my-0 mx-auto">{responseMessage}</p>
                <p
                  className="my-0 cursor-pointer"
                  onClick={() => setResponseMessage(false)}
                >
                  <i className="fa-solid fa-xmark"></i>
                </p>
              </div>
            )}
    </section>
  );
};

export default PlotInventory;
